module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/privacy-policy-html.json
// module id = 755
// module chunks = 181422344514063